module.exports = __webpack_public_path__ + "img/1.3edab7ce.jpg";